<template>
    <div class="switch-active roboto-normal-18 clr-black-9d pointer" @click="$emit('toggle')" :style="{visibility: (allLength !== activeLength || allLength > 4) ? 'visible' : 'hidden'}">
        <div class="ml-2" v-show="$vuetify.breakpoint.xlOnly">Показать:</div>
        <div v-if="all" class="ml-2">Активные ({{activeLength}})</div>
        <div v-else class="ml-2">Все ({{allLength}})</div>
        <img v-if="!all" class="mt-n1" height="29px" src="@/assets/images/components/arrow-up.svg">
        <img v-if="all"  class="mt-n1" height="29px" src="@/assets/images/components/arrow-down.svg">
    </div>
</template>

<script lang='ts'>
    import { Vue } from 'vue-property-decorator'
    import { PropType } from 'vue'

    export default Vue.extend({
        props: {
            activeLength: Number,
            allLength: Number,
            all: Boolean,
        },
        components: {

        },
        data() {
            return {
                
            }
        },
        computed: {

        },
        methods: {

        },
    })

    </script>

<style lang="scss" scoped>

</style>
